// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* User Manager Styles - Clean Modern Theme */
.user-manager {
  max-width: 1400px;
  margin: 0 auto;
  padding: var(--dashboard-space-6);
}

.user-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: var(--dashboard-space-8);
  padding: var(--dashboard-space-6);
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
  backdrop-filter: blur(20px);
}

.user-header h2 {
  margin: 0;
  color: var(--dashboard-text-primary);
  font-size: 2rem;
  font-weight: 700;
  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.add-user-btn {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  border: none;
  padding: var(--dashboard-space-3) var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-lg);
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-2);
  transition: all 0.2s ease;
  box-shadow: var(--dashboard-shadow-md);
  position: relative;
  overflow: hidden;
}

.add-user-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);
  transition: left 0.5s ease;
}

.add-user-btn:hover::before {
  left: 100%;
}

.add-user-btn:hover {
  transform: translateY(-2px);
  box-shadow: var(--dashboard-shadow-lg);
}

.add-user-btn:active {
  transform: translateY(0);
}

.add-user-btn span {
  font-size: 1.125rem;
}

/* User Table Styles */
.users-table-container {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  box-shadow: var(--dashboard-shadow-sm);
  border: 1px solid var(--dashboard-border);
  overflow: hidden;
  backdrop-filter: blur(20px);
}

.users-table {
  width: 100%;
  border-collapse: collapse;
  background: transparent;
}

.users-table th {
  background: var(--dashboard-bg-secondary);
  color: var(--dashboard-text-secondary);
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  padding: var(--dashboard-space-4) var(--dashboard-space-6);
  text-align: left;
  border-bottom: 1px solid var(--dashboard-border);
}

.users-table td {
  padding: var(--dashboard-space-4) var(--dashboard-space-6);
  border-bottom: 1px solid var(--dashboard-border);
  color: var(--dashboard-text-primary);
  font-size: 0.875rem;
}

.users-table tr:last-child td {
  border-bottom: none;
}

.users-table tr:hover {
  background: var(--dashboard-bg-hover);
}

/* Role Badges */
.role-badge {
  display: inline-block;
  padding: var(--dashboard-space-1) var(--dashboard-space-3);
  border-radius: var(--dashboard-radius-lg);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.role-badge.user {
  background: rgba(34, 197, 94, 0.1);
  color: rgb(34, 197, 94);
  border: 1px solid rgba(34, 197, 94, 0.2);
}

.role-badge.admin {
  background: rgba(239, 68, 68, 0.1);
  color: rgb(239, 68, 68);
  border: 1px solid rgba(239, 68, 68, 0.2);
}

.role-badge.super_admin {
  background: rgba(147, 51, 234, 0.1);
  color: rgb(147, 51, 234);
  border: 1px solid rgba(147, 51, 234, 0.2);
}

/* Status Indicators */
.status-indicator {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-2);
  font-size: 0.875rem;
  font-weight: 500;
}

.status-indicator.active {
  color: rgb(34, 197, 94);
}

.status-indicator.active::before {
  content: '';
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgb(34, 197, 94);
}

/* Action Buttons */
.action-buttons {
  display: flex;
  gap: var(--dashboard-space-2);
}

.action-btn {
  padding: var(--dashboard-space-2) var(--dashboard-space-3);
  border-radius: var(--dashboard-radius-md);
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.action-btn.edit {
  background: rgba(251, 191, 36, 0.1);
  color: rgb(251, 191, 36);
  border: 1px solid rgba(251, 191, 36, 0.2);
}

.action-btn.edit:hover {
  background: rgba(251, 191, 36, 0.2);
  transform: translateY(-1px);
}

.action-btn.manage {
  background: rgba(59, 130, 246, 0.1);
  color: rgb(59, 130, 246);
  border: 1px solid rgba(59, 130, 246, 0.2);
}

.action-btn.manage:hover {
  background: rgba(59, 130, 246, 0.2);
  transform: translateY(-1px);
}

/* Modal Styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(8px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: var(--dashboard-space-4);
}

.modal-content {
  background: var(--dashboard-card-bg);
  border-radius: var(--dashboard-radius-xl);
  box-shadow: var(--dashboard-shadow-2xl);
  border: 1px solid var(--dashboard-border);
  max-width: 500px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  backdrop-filter: blur(20px);
}

.modal-header {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
  padding: var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-xl) var(--dashboard-radius-xl) 0 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.close-btn {
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid rgba(255, 255, 255, 0.3);
  color: white;
  width: 32px;
  height: 32px;
  border-radius: var(--dashboard-radius-md);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.3);
}

.modal-body {
  padding: var(--dashboard-space-6);
}

/* Form Styles */
.form-group {
  margin-bottom: var(--dashboard-space-4);
}

.form-label {
  display: block;
  font-weight: 600;
  color: var(--dashboard-text-primary);
  margin-bottom: var(--dashboard-space-2);
  font-size: 0.875rem;
}

.form-input,
.form-select {
  width: 100%;
  padding: var(--dashboard-space-3);
  border: 1px solid var(--dashboard-border);
  border-radius: var(--dashboard-radius-md);
  font-size: 0.875rem;
  background: var(--dashboard-bg-primary);
  color: var(--dashboard-text-primary);
  transition: all 0.2s ease;
}

.form-input:focus,
.form-select:focus {
  outline: none;
  border-color: var(--dashboard-primary);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.checkbox-group {
  display: flex;
  align-items: center;
  gap: var(--dashboard-space-2);
  margin: var(--dashboard-space-4) 0;
}

.checkbox-group input[type="checkbox"] {
  width: 16px;
  height: 16px;
  accent-color: var(--dashboard-primary);
}

.checkbox-group label {
  font-size: 0.875rem;
  color: var(--dashboard-text-primary);
  margin: 0;
}

/* Button Groups */
.button-group {
  display: flex;
  justify-content: flex-end;
  gap: var(--dashboard-space-3);
  margin-top: var(--dashboard-space-6);
}

.btn {
  padding: var(--dashboard-space-3) var(--dashboard-space-6);
  border-radius: var(--dashboard-radius-md);
  font-size: 0.875rem;
  font-weight: 600;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);
  color: white;
}

.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: var(--dashboard-shadow-md);
}

.btn-secondary {
  background: var(--dashboard-bg-secondary);
  color: var(--dashboard-text-secondary);
  border: 1px solid var(--dashboard-border);
}

.btn-secondary:hover {
  background: var(--dashboard-bg-hover);
}

/* Additional styles for user badges */
.current-user-badge {
  background: rgba(34, 197, 94, 0.1);
  color: rgb(34, 197, 94);
  font-size: 0.6rem;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 4px;
  margin-left: var(--dashboard-space-2);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.username {
  font-weight: 600;
  color: var(--dashboard-text-primary);
  display: flex;
  align-items: center;
}

/* Instance Access Styles */
.instance-list {
  display: flex;
  flex-direction: column;
  gap: var(--dashboard-space-3);
  margin: var(--dashboard-space-4) 0;
}

.instance-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--dashboard-space-4);
  background: var(--dashboard-bg-secondary);
  border-radius: var(--dashboard-radius-md);
  border: 1px solid var(--dashboard-border);
}

.instance-info h4 {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--dashboard-text-primary);
}

.instance-info p {
  margin: var(--dashboard-space-1) 0 0 0;
  font-size: 0.75rem;
  color: var(--dashboard-text-secondary);
}

.instance-status {
  font-size: 0.75rem;
  font-weight: 500;
  margin-left: var(--dashboard-space-2);
}

.instance-status.connected {
  color: rgb(34, 197, 94);
}

.instance-status.disconnected {
  color: rgb(239, 68, 68);
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  width: 44px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: var(--dashboard-border);
  border-radius: 24px;
  transition: 0.3s ease;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background: white;
  border-radius: 50%;
  transition: 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.toggle-switch input:checked + .toggle-slider {
  background: var(--dashboard-primary);
}

.toggle-switch input:checked + .toggle-slider:before {
  transform: translateX(20px);
}

/* Loading Spinner */
.loading-spinner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 400px;
  gap: var(--dashboard-space-4);
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid var(--dashboard-border);
  border-top: 3px solid var(--dashboard-primary);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-spinner p {
  color: var(--dashboard-text-secondary);
  font-weight: 500;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 768px) {
  .user-manager {
    padding: var(--dashboard-space-4);
  }
  
  .user-header {
    flex-direction: column;
    gap: var(--dashboard-space-4);
    text-align: center;
  }
  
  .users-table-container {
    overflow-x: auto;
  }
  
  .modal-content {
    max-width: 95vw;
    margin: var(--dashboard-space-4);
  }
  
  .instance-item {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--dashboard-space-3);
  }
  
  .action-buttons {
    flex-wrap: wrap;
  }
}

.table-row {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr 2fr;
  gap: var(--space-lg);
  padding: var(--space-lg) var(--space-xl);
  border-bottom: 1px solid var(--gray-100);
  transition: all var(--transition-base);
}

.table-row:hover {
  background: var(--gray-50);
  transform: translateX(4px);
}

.table-row:last-child {
  border-bottom: none;
}

.table-cell {
  display: flex;
  align-items: center;
  font-size: var(--font-size-sm);
}

.user-info {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}

.username {
  font-weight: var(--font-weight-semibold);
  color: var(--gray-700);
}

.current-user {
  background: linear-gradient(135deg, var(--success-color) 0%, var(--success-light) 100%);
  color: var(--white);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-lg);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.role-badge {
  color: var(--white);
  padding: var(--space-xs) var(--space-sm);
  border-radius: var(--radius-lg);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  box-shadow: var(--shadow-sm);
}

.status-active {
  color: var(--success-color);
  font-weight: var(--font-weight-semibold);
  display: flex;
  align-items: center;
  gap: var(--space-xs);
}

.status-active::before {
  content: '●';
  color: var(--success-color);
}

.action-buttons {
  display: flex;
  gap: var(--space-sm);
}

.edit-btn,
.manage-access-btn {
  padding: var(--space-sm) var(--space-md);
  border: none;
  border-radius: var(--radius-md);
  cursor: pointer;
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-semibold);
  transition: all var(--transition-base);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.edit-btn {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);
  color: var(--white);
  box-shadow: var(--shadow-sm);
}

.edit-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

.manage-access-btn {
  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-light) 100%);
  color: var(--white);
  box-shadow: var(--shadow-sm);
}

.manage-access-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-md);
}

/* Modal Styles */
.add-user-modal,
.edit-user-modal,
.assign-access-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: var(--z-modal);
  padding: var(--space-lg);
  backdrop-filter: blur(5px);
}

.modal-content {
  background: var(--white);
  border-radius: var(--radius-2xl);
  width: 100%;
  max-width: 500px;
  box-shadow: var(--shadow-2xl);
  border: 1px solid var(--gray-200);
  overflow: hidden;
  animation: modalSlideIn 0.3s ease-out;
}

.access-modal-content {
  max-width: 700px;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-xl);
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);
  color: var(--white);
}

.modal-header h3 {
  margin: 0;
  color: var(--white);
  font-size: var(--font-size-xl);
  font-weight: var(--font-weight-bold);
}

.close-btn {
  background: rgba(255, 255, 255, 0.15);
  border: 1px solid rgba(255, 255, 255, 0.2);
  font-size: var(--font-size-xl);
  cursor: pointer;
  color: var(--white);
  padding: var(--space-sm);
  width: 40px;
  height: 40px;
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all var(--transition-fast);
  backdrop-filter: blur(10px);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.25);
  transform: scale(1.05);
}

/* Form Styles */
.user-form {
  padding: var(--space-xl);
}

.form-group {
  margin-bottom: var(--space-lg);
}

.form-group label {
  display: block;
  margin-bottom: var(--space-sm);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--gray-700);
}

.form-group input,
.form-group select {
  width: 100%;
  padding: var(--space-md);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-tight);
  color: var(--gray-700);
  background-color: var(--white);
  border: 1px solid var(--gray-300);
  border-radius: var(--radius-lg);
  transition: all var(--transition-fast);
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);
  transform: translateY(-1px);
}

.password-section {
  margin-bottom: var(--space-lg);
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  cursor: pointer;
  margin-bottom: 0;
}

.checkbox-label input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.checkbox-text {
  font-size: var(--font-size-sm);
  color: var(--gray-700);
}

.password-hint {
  font-size: var(--font-size-xs);
  color: var(--gray-500);
  margin-top: var(--space-xs);
  font-style: italic;
}

.form-actions {
  display: flex;
  gap: var(--space-md);
  justify-content: flex-end;
  padding-top: var(--space-lg);
  border-top: 1px solid var(--gray-200);
}

.cancel-btn {
  background: var(--gray-100);
  color: var(--gray-700);
  border: 1px solid var(--gray-300);
  padding: var(--space-md) var(--space-xl);
  border-radius: var(--radius-lg);
  cursor: pointer;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-medium);
  transition: all var(--transition-fast);
}

.cancel-btn:hover {
  background: var(--gray-200);
  border-color: var(--gray-400);
}

.create-btn,
.save-btn {
  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);
  color: var(--white);
  border: none;
  padding: var(--space-md) var(--space-xl);
  border-radius: var(--radius-lg);
  cursor: pointer;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  transition: all var(--transition-base);
  box-shadow: var(--shadow-md);
}

.create-btn:hover,
.save-btn:hover {
  transform: translateY(-1px);
  box-shadow: var(--shadow-lg);
/* Access Management Styles */
.access-list {
  padding: var(--space-xl);
}

.access-header h4 {
  margin: 0 0 var(--space-sm) 0;
  color: var(--primary-color);
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
}

.access-header p {
  margin: 0 0 var(--space-xl) 0;
  color: var(--gray-600);
  font-size: var(--font-size-sm);
  line-height: var(--line-height-relaxed);
}

.instances-grid {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
  max-height: 400px;
  overflow-y: auto;
}

.access-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--space-lg);
  background: var(--gray-50);
  border-radius: var(--radius-lg);
  border: 1px solid var(--gray-200);
  transition: all var(--transition-base);
}

.access-item:hover {
  background: var(--gray-100);
  border-color: var(--primary-color);
}

.instance-info {
  flex: 1 1;
}

.instance-name {
  font-weight: var(--font-weight-semibold);
  color: var(--gray-700);
  font-size: var(--font-size-base);
  margin-bottom: var(--space-xs);
}

.instance-details {
  font-size: var(--font-size-sm);
  color: var(--gray-500);
}

.instance-details .status {
  font-weight: var(--font-weight-semibold);
  text-transform: uppercase;
}

.instance-details .status.connected {
  color: var(--success-color);
}

.instance-details .status.connecting {
  color: var(--warning-color);
}

.instance-details .status.disconnected {
  color: var(--error-color);
}

.access-control {
  margin-left: var(--space-lg);
}

/* Toggle Switch */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--gray-300);
  transition: all var(--transition-base);
  border-radius: 34px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: var(--white);
  transition: all var(--transition-base);
  border-radius: 50%;
  box-shadow: var(--shadow-sm);
}

input:checked + .toggle-slider {
  background-color: var(--primary-color);
}

input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

.modal-footer {
  padding: var(--space-xl);
  background: var(--gray-50);
  border-top: 1px solid var(--gray-200);
  display: flex;
  justify-content: flex-end;
  gap: var(--space-md);
}

/* Loading State */
.loading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 200px;
  background: var(--white);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .table-header,
  .table-row {
    grid-template-columns: 2fr 1fr 1fr 1.5fr;
  }
  
  .header-cell:last-child,
  .table-cell:last-child {
    grid-column: 1 / -1;
    margin-top: var(--space-sm);
  }
}

@media (max-width: 768px) {
  .user-manager {
    padding: 0;
  }
  
  .user-header {
    flex-direction: column;
    gap: var(--space-lg);
    align-items: stretch;
    text-align: center;
  }
  
  .users-table {
    overflow-x: auto;
  }
  
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: var(--space-sm);
    text-align: center;
  }
  
  .table-header {
    display: none;
  }
  
  .table-row {
    display: flex;
    flex-direction: column;
    padding: var(--space-lg);
    border: 1px solid var(--gray-200);
    border-radius: var(--radius-lg);
    margin-bottom: var(--space-md);
    background: var(--white);
  }
  
  .table-cell {
    justify-content: center;
    border-bottom: 1px solid var(--gray-100);
    padding-bottom: var(--space-sm);
    margin-bottom: var(--space-sm);
  }
  
  .table-cell:last-child {
    border-bottom: none;
    margin-bottom: 0;
    padding-bottom: 0;
  }
  
  .action-buttons {
    flex-direction: column;
    width: 100%;
  }
  
  .edit-btn,
  .manage-access-btn {
    width: 100%;
    justify-content: center;
  }
  
  .modal-content {
    margin: var(--space-md);
    max-width: calc(100vw - 2rem);
  }
  
  .access-modal-content {
    max-width: calc(100vw - 2rem);
  }
  
  .instances-grid {
    max-height: 300px;
  }
  
  .access-item {
    flex-direction: column;
    align-items: flex-start;
    gap: var(--space-md);
  }
  
  .access-control {
    margin-left: 0;
    align-self: flex-end;
  }
}

@media (max-width: 480px) {
  .user-header,
  .user-form,
  .access-list,
  .modal-footer {
    padding: var(--space-md);
  }
  
  .form-actions,
  .modal-footer {
    flex-direction: column;
  }
  
  .cancel-btn,
  .create-btn,
  .save-btn {
    width: 100%;
    justify-content: center;
  }
}
  border-radius: 8px;
  font-size: 14px;
  transition: border-color 0.3s ease;
  box-sizing: border-box;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: #25D366;
}

.form-actions {
  display: flex;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #e0e0e0;
}

.cancel-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  flex: 1 1;
  transition: background-color 0.3s ease;
}

.cancel-btn:hover {
  background: #545b62;
}

.create-btn {
  background: #25D366;
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  flex: 1 1;
  transition: background-color 0.3s ease;
}

.create-btn:hover {
  background: #1da851;
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 16px;
  color: #666;
}

/* Responsive Design */
@media (max-width: 768px) {
  .table-header,
  .table-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  
  .table-cell {
    justify-content: space-between;
    padding: 4px 0;
  }
  
  .table-cell::before {
    content: attr(data-label);
    font-weight: 600;
    color: #075E54;
    font-size: 12px;
    text-transform: uppercase;
  }
  
  .header-cell {
    display: none;
  }
  
  .user-header {
    flex-direction: column;
    gap: 16px;
    align-items: stretch;
  }
  
  .user-header h2 {
    text-align: center;
  }
}

/* Action Buttons Styling */
.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.edit-btn {
  background: #ffc107;
  color: #000;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.edit-btn:hover {
  background: #e0a800;
  transform: translateY(-1px);
}

.manage-access-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.manage-access-btn:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

/* Edit User Modal */
.edit-user-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

/* Access Modal Enhanced Styling */
.assign-access-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 20px;
}

.access-modal-content {
  max-width: 600px !important;
  max-height: 80vh;
  overflow-y: auto;
}

.access-header {
  margin-bottom: 20px;
}

.access-header h4 {
  margin: 0 0 8px 0;
  color: #075E54;
  font-size: 18px;
}

.access-header p {
  margin: 0;
  color: #666;
  font-size: 14px;
}

.instances-grid {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.access-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f8f9fa;
  transition: all 0.3s ease;
}

.access-item:hover {
  background: #e9ecef;
  border-color: #007bff;
}

.instance-info {
  flex: 1 1;
}

.instance-name {
  font-weight: 600;
  color: #333;
  font-size: 14px;
  margin-bottom: 4px;
}

.instance-details {
  font-size: 12px;
  color: #666;
}

.instance-details .status {
  font-weight: 500;
  text-transform: capitalize;
}

.instance-details .status.connected {
  color: #28a745;
}

.instance-details .status.disconnected {
  color: #dc3545;
}

.access-control {
  margin-left: 16px;
}

/* Toggle Switch Styling */
.toggle-switch {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 24px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background-color: #25D366;
}

input:checked + .toggle-slider:before {
  transform: translateX(26px);
}

/* Modal Footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
  padding-top: 20px;
  border-top: 1px solid #e0e0e0;
}

.save-btn {
  background: #25D366;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.save-btn:hover {
  background: #1da851;
  transform: translateY(-1px);
}

/* Responsive for mobile */
@media (max-width: 768px) {
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
  
  .edit-btn, .manage-access-btn {
    width: 100%;
    text-align: center;
  }
  
  .access-modal-content {
    margin: 10px;
    max-height: 90vh;
  }
  
  .access-item {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }
  
  .access-control {
    margin-left: 0;
  }
}

/* Password Section Styling */
.password-section {
  border-top: 1px solid #e0e0e0;
  margin-top: 16px;
  padding-top: 16px;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  margin: 0;
}

.checkbox-label input[type="checkbox"] {
  margin: 0;
  transform: scale(1.1);
}

.checkbox-text {
  font-weight: 500;
  color: #333;
}

.password-hint {
  display: block;
  margin-top: 4px;
  color: #666;
  font-size: 12px;
  font-style: italic;
}

/* Enhanced Form Groups */
.form-group label {
  display: block;
  margin-bottom: 6px;
  font-weight: 500;
  color: #333;
}

.form-group input[type="text"],
.form-group input[type="password"],
.form-group select {
  width: 100%;
  padding: 10px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  transition: border-color 0.3s ease;
}

.form-group input[type="text"]:focus,
.form-group input[type="password"]:focus,
.form-group select:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Validation States */
.form-group input:invalid {
  border-color: #dc3545;
}

.form-group input:valid {
  border-color: #28a745;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserManager.css"],"names":[],"mappings":"AAAA,6CAA6C;AAC7C;EACE,iBAAiB;EACjB,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,uCAAuC;EACvC,iCAAiC;EACjC,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,oGAAoG;EACpG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,YAAY;EACZ,0DAA0D;EAC1D,yCAAyC;EACzC,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,mFAAmF;EACnF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,oCAAoC;EACpC,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;EACzC,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,0DAA0D;EAC1D,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,0DAA0D;EAC1D,gDAAgD;EAChD,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,0DAA0D;EAC1D,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,0DAA0D;EAC1D,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA;EACE,mCAAmC;EACnC,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,uCAAuC;EACvC,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,iGAAiG;EACjG,YAAY;EACZ,iCAAiC;EACjC,wEAAwE;EACxE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;EACzC,mBAAmB;EACnB,uCAAuC;EACvC,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,sCAAsC;EACtC,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,SAAS;AACX;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,0DAA0D;EAC1D,yCAAyC;EACzC,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iGAAiG;EACjG,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE,yCAAyC;EACzC,sCAAsC;EACtC,yCAAyC;AAC3C;;AAEA;EAKE,qCAAqC;AAHvC;;AAMA,sCAAsC;AACtC;EACE,kCAAkC;EAClC,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,aAAa;EACb,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iCAAiC;EACjC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,8CAA8C;EAC9C,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA;EACE,sCAAsC;EACtC,gBAAgB;EAChB,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE;IACE,iCAAiC;EACnC;;EAEA;IACE,sBAAsB;IACtB,6BAA6B;IAC7B,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,oBAAoB;EACpB,wCAAwC;EACxC,wCAAwC;EACxC,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;EACvF,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;EACxC,+BAA+B;EAC/B,8BAA8B;EAC9B,wCAAwC;EACxC,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,oBAAoB;AACtB;;AAEA;;EAEE,wCAAwC;EACxC,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,8BAA8B;EAC9B,wCAAwC;EACxC,sCAAsC;EACtC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,uFAAuF;EACvF,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,2FAA2F;EAC3F,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,iBAAiB;AACjB;;;EAGE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,WAAW;EACX,gBAAgB;EAChB,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,uFAAuF;EACvF,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,8BAA8B;EAC9B,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,8BAA8B;EAC9B,qCAAqC;EACrC,sBAAsB;EACtB,8BAA8B;EAC9B,iCAAiC;EACjC,+BAA+B;EAC/B,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,kCAAkC;EAClC,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,yBAAyB;EACzB,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,iCAAiC;EACjC,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;EACf,8BAA8B;EAC9B,sCAAsC;EACtC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;;EAEE,uFAAuF;EACvF,mBAAmB;EACnB,YAAY;EACZ,wCAAwC;EACxC,+BAA+B;EAC/B,eAAe;EACf,8BAA8B;EAC9B,wCAAwC;EACxC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;;EAEE,2BAA2B;EAC3B,4BAA4B;AAC9B,6BAA6B;AAC7B;EACE,wBAAwB;AAC1B;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;EAC3B,8BAA8B;EAC9B,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,wBAAwB;EACxB,0BAA0B;EAC1B,+BAA+B;EAC/B,iCAAiC;EACjC,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,gCAAgC;EAChC,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,iCAAiC;EACjC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,8BAA8B;EAC9B,sCAAsC;EACtC,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,qCAAqC;EACrC,aAAa;EACb,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE;;IAEE,wCAAwC;EAC1C;;EAEA;;IAEE,mBAAmB;IACnB,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;IACpB,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,0BAA0B;IAC1B,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,iCAAiC;IACjC,+BAA+B;IAC/B,8BAA8B;IAC9B,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,wCAAwC;IACxC,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,WAAW;EACb;;EAEA;;IAEE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,cAAc;IACd,oBAAoB;EACtB;AACF;;AAEA;EACE;;;;IAIE,wBAAwB;EAC1B;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;;IAGE,WAAW;IACX,uBAAuB;EACzB;AACF;EACE,kBAAkB;EAClB,eAAe;EACf,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;EACP,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;EACP,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,sBAAsB;AACtB;EACE;;IAEE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA,6BAA6B;AAC7B;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":["/* User Manager Styles - Clean Modern Theme */\n.user-manager {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: var(--dashboard-space-6);\n}\n\n.user-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: var(--dashboard-space-8);\n  padding: var(--dashboard-space-6);\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n  backdrop-filter: blur(20px);\n}\n\n.user-header h2 {\n  margin: 0;\n  color: var(--dashboard-text-primary);\n  font-size: 2rem;\n  font-weight: 700;\n  background: linear-gradient(135deg, var(--dashboard-text-primary) 0%, var(--dashboard-primary) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.add-user-btn {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  border: none;\n  padding: var(--dashboard-space-3) var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-lg);\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n  transition: all 0.2s ease;\n  box-shadow: var(--dashboard-shadow-md);\n  position: relative;\n  overflow: hidden;\n}\n\n.add-user-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.add-user-btn:hover::before {\n  left: 100%;\n}\n\n.add-user-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--dashboard-shadow-lg);\n}\n\n.add-user-btn:active {\n  transform: translateY(0);\n}\n\n.add-user-btn span {\n  font-size: 1.125rem;\n}\n\n/* User Table Styles */\n.users-table-container {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  box-shadow: var(--dashboard-shadow-sm);\n  border: 1px solid var(--dashboard-border);\n  overflow: hidden;\n  backdrop-filter: blur(20px);\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: transparent;\n}\n\n.users-table th {\n  background: var(--dashboard-bg-secondary);\n  color: var(--dashboard-text-secondary);\n  font-weight: 600;\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  padding: var(--dashboard-space-4) var(--dashboard-space-6);\n  text-align: left;\n  border-bottom: 1px solid var(--dashboard-border);\n}\n\n.users-table td {\n  padding: var(--dashboard-space-4) var(--dashboard-space-6);\n  border-bottom: 1px solid var(--dashboard-border);\n  color: var(--dashboard-text-primary);\n  font-size: 0.875rem;\n}\n\n.users-table tr:last-child td {\n  border-bottom: none;\n}\n\n.users-table tr:hover {\n  background: var(--dashboard-bg-hover);\n}\n\n/* Role Badges */\n.role-badge {\n  display: inline-block;\n  padding: var(--dashboard-space-1) var(--dashboard-space-3);\n  border-radius: var(--dashboard-radius-lg);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.role-badge.user {\n  background: rgba(34, 197, 94, 0.1);\n  color: rgb(34, 197, 94);\n  border: 1px solid rgba(34, 197, 94, 0.2);\n}\n\n.role-badge.admin {\n  background: rgba(239, 68, 68, 0.1);\n  color: rgb(239, 68, 68);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n}\n\n.role-badge.super_admin {\n  background: rgba(147, 51, 234, 0.1);\n  color: rgb(147, 51, 234);\n  border: 1px solid rgba(147, 51, 234, 0.2);\n}\n\n/* Status Indicators */\n.status-indicator {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.status-indicator.active {\n  color: rgb(34, 197, 94);\n}\n\n.status-indicator.active::before {\n  content: '';\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: rgb(34, 197, 94);\n}\n\n/* Action Buttons */\n.action-buttons {\n  display: flex;\n  gap: var(--dashboard-space-2);\n}\n\n.action-btn {\n  padding: var(--dashboard-space-2) var(--dashboard-space-3);\n  border-radius: var(--dashboard-radius-md);\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.action-btn.edit {\n  background: rgba(251, 191, 36, 0.1);\n  color: rgb(251, 191, 36);\n  border: 1px solid rgba(251, 191, 36, 0.2);\n}\n\n.action-btn.edit:hover {\n  background: rgba(251, 191, 36, 0.2);\n  transform: translateY(-1px);\n}\n\n.action-btn.manage {\n  background: rgba(59, 130, 246, 0.1);\n  color: rgb(59, 130, 246);\n  border: 1px solid rgba(59, 130, 246, 0.2);\n}\n\n.action-btn.manage:hover {\n  background: rgba(59, 130, 246, 0.2);\n  transform: translateY(-1px);\n}\n\n/* Modal Styles */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  backdrop-filter: blur(8px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: var(--dashboard-space-4);\n}\n\n.modal-content {\n  background: var(--dashboard-card-bg);\n  border-radius: var(--dashboard-radius-xl);\n  box-shadow: var(--dashboard-shadow-2xl);\n  border: 1px solid var(--dashboard-border);\n  max-width: 500px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  backdrop-filter: blur(20px);\n}\n\n.modal-header {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n  padding: var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-xl) var(--dashboard-radius-xl) 0 0;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h3 {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.close-btn {\n  background: rgba(255, 255, 255, 0.2);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  color: white;\n  width: 32px;\n  height: 32px;\n  border-radius: var(--dashboard-radius-md);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.modal-body {\n  padding: var(--dashboard-space-6);\n}\n\n/* Form Styles */\n.form-group {\n  margin-bottom: var(--dashboard-space-4);\n}\n\n.form-label {\n  display: block;\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n  margin-bottom: var(--dashboard-space-2);\n  font-size: 0.875rem;\n}\n\n.form-input,\n.form-select {\n  width: 100%;\n  padding: var(--dashboard-space-3);\n  border: 1px solid var(--dashboard-border);\n  border-radius: var(--dashboard-radius-md);\n  font-size: 0.875rem;\n  background: var(--dashboard-bg-primary);\n  color: var(--dashboard-text-primary);\n  transition: all 0.2s ease;\n}\n\n.form-input:focus,\n.form-select:focus {\n  outline: none;\n  border-color: var(--dashboard-primary);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.checkbox-group {\n  display: flex;\n  align-items: center;\n  gap: var(--dashboard-space-2);\n  margin: var(--dashboard-space-4) 0;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--dashboard-primary);\n}\n\n.checkbox-group label {\n  font-size: 0.875rem;\n  color: var(--dashboard-text-primary);\n  margin: 0;\n}\n\n/* Button Groups */\n.button-group {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--dashboard-space-3);\n  margin-top: var(--dashboard-space-6);\n}\n\n.btn {\n  padding: var(--dashboard-space-3) var(--dashboard-space-6);\n  border-radius: var(--dashboard-radius-md);\n  font-size: 0.875rem;\n  font-weight: 600;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, var(--dashboard-primary) 0%, var(--dashboard-secondary) 100%);\n  color: white;\n}\n\n.btn-primary:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--dashboard-shadow-md);\n}\n\n.btn-secondary {\n  background: var(--dashboard-bg-secondary);\n  color: var(--dashboard-text-secondary);\n  border: 1px solid var(--dashboard-border);\n}\n\n.btn-secondary:hover {\n  background: var(--dashboard-bg-hover);\n}\n\n.btn-secondary:hover {\n  background: var(--dashboard-bg-hover);\n}\n\n/* Additional styles for user badges */\n.current-user-badge {\n  background: rgba(34, 197, 94, 0.1);\n  color: rgb(34, 197, 94);\n  font-size: 0.6rem;\n  font-weight: 600;\n  padding: 2px 6px;\n  border-radius: 4px;\n  margin-left: var(--dashboard-space-2);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.username {\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n  display: flex;\n  align-items: center;\n}\n\n/* Instance Access Styles */\n.instance-list {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dashboard-space-3);\n  margin: var(--dashboard-space-4) 0;\n}\n\n.instance-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--dashboard-space-4);\n  background: var(--dashboard-bg-secondary);\n  border-radius: var(--dashboard-radius-md);\n  border: 1px solid var(--dashboard-border);\n}\n\n.instance-info h4 {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--dashboard-text-primary);\n}\n\n.instance-info p {\n  margin: var(--dashboard-space-1) 0 0 0;\n  font-size: 0.75rem;\n  color: var(--dashboard-text-secondary);\n}\n\n.instance-status {\n  font-size: 0.75rem;\n  font-weight: 500;\n  margin-left: var(--dashboard-space-2);\n}\n\n.instance-status.connected {\n  color: rgb(34, 197, 94);\n}\n\n.instance-status.disconnected {\n  color: rgb(239, 68, 68);\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  width: 44px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: var(--dashboard-border);\n  border-radius: 24px;\n  transition: 0.3s ease;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background: white;\n  border-radius: 50%;\n  transition: 0.3s ease;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.toggle-switch input:checked + .toggle-slider {\n  background: var(--dashboard-primary);\n}\n\n.toggle-switch input:checked + .toggle-slider:before {\n  transform: translateX(20px);\n}\n\n/* Loading Spinner */\n.loading-spinner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 400px;\n  gap: var(--dashboard-space-4);\n}\n\n.spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid var(--dashboard-border);\n  border-top: 3px solid var(--dashboard-primary);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n.loading-spinner p {\n  color: var(--dashboard-text-secondary);\n  font-weight: 500;\n  margin: 0;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .user-manager {\n    padding: var(--dashboard-space-4);\n  }\n  \n  .user-header {\n    flex-direction: column;\n    gap: var(--dashboard-space-4);\n    text-align: center;\n  }\n  \n  .users-table-container {\n    overflow-x: auto;\n  }\n  \n  .modal-content {\n    max-width: 95vw;\n    margin: var(--dashboard-space-4);\n  }\n  \n  .instance-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--dashboard-space-3);\n  }\n  \n  .action-buttons {\n    flex-wrap: wrap;\n  }\n}\n\n.table-row {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr 2fr;\n  gap: var(--space-lg);\n  padding: var(--space-lg) var(--space-xl);\n  border-bottom: 1px solid var(--gray-100);\n  transition: all var(--transition-base);\n}\n\n.table-row:hover {\n  background: var(--gray-50);\n  transform: translateX(4px);\n}\n\n.table-row:last-child {\n  border-bottom: none;\n}\n\n.table-cell {\n  display: flex;\n  align-items: center;\n  font-size: var(--font-size-sm);\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n}\n\n.username {\n  font-weight: var(--font-weight-semibold);\n  color: var(--gray-700);\n}\n\n.current-user {\n  background: linear-gradient(135deg, var(--success-color) 0%, var(--success-light) 100%);\n  color: var(--white);\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.role-badge {\n  color: var(--white);\n  padding: var(--space-xs) var(--space-sm);\n  border-radius: var(--radius-lg);\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  box-shadow: var(--shadow-sm);\n}\n\n.status-active {\n  color: var(--success-color);\n  font-weight: var(--font-weight-semibold);\n  display: flex;\n  align-items: center;\n  gap: var(--space-xs);\n}\n\n.status-active::before {\n  content: '●';\n  color: var(--success-color);\n}\n\n.action-buttons {\n  display: flex;\n  gap: var(--space-sm);\n}\n\n.edit-btn,\n.manage-access-btn {\n  padding: var(--space-sm) var(--space-md);\n  border: none;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  font-size: var(--font-size-xs);\n  font-weight: var(--font-weight-semibold);\n  transition: all var(--transition-base);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.edit-btn {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);\n  color: var(--white);\n  box-shadow: var(--shadow-sm);\n}\n\n.edit-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n.manage-access-btn {\n  background: linear-gradient(135deg, var(--secondary-color) 0%, var(--secondary-light) 100%);\n  color: var(--white);\n  box-shadow: var(--shadow-sm);\n}\n\n.manage-access-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-md);\n}\n\n/* Modal Styles */\n.add-user-modal,\n.edit-user-modal,\n.assign-access-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: var(--z-modal);\n  padding: var(--space-lg);\n  backdrop-filter: blur(5px);\n}\n\n.modal-content {\n  background: var(--white);\n  border-radius: var(--radius-2xl);\n  width: 100%;\n  max-width: 500px;\n  box-shadow: var(--shadow-2xl);\n  border: 1px solid var(--gray-200);\n  overflow: hidden;\n  animation: modalSlideIn 0.3s ease-out;\n}\n\n.access-modal-content {\n  max-width: 700px;\n}\n\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-xl);\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);\n  color: var(--white);\n}\n\n.modal-header h3 {\n  margin: 0;\n  color: var(--white);\n  font-size: var(--font-size-xl);\n  font-weight: var(--font-weight-bold);\n}\n\n.close-btn {\n  background: rgba(255, 255, 255, 0.15);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  font-size: var(--font-size-xl);\n  cursor: pointer;\n  color: var(--white);\n  padding: var(--space-sm);\n  width: 40px;\n  height: 40px;\n  border-radius: var(--radius-lg);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all var(--transition-fast);\n  backdrop-filter: blur(10px);\n}\n\n.close-btn:hover {\n  background: rgba(255, 255, 255, 0.25);\n  transform: scale(1.05);\n}\n\n/* Form Styles */\n.user-form {\n  padding: var(--space-xl);\n}\n\n.form-group {\n  margin-bottom: var(--space-lg);\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: var(--space-sm);\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  color: var(--gray-700);\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: var(--space-md);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-tight);\n  color: var(--gray-700);\n  background-color: var(--white);\n  border: 1px solid var(--gray-300);\n  border-radius: var(--radius-lg);\n  transition: all var(--transition-fast);\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(26, 54, 93, 0.1);\n  transform: translateY(-1px);\n}\n\n.password-section {\n  margin-bottom: var(--space-lg);\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: var(--space-sm);\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  width: auto;\n  margin: 0;\n}\n\n.checkbox-text {\n  font-size: var(--font-size-sm);\n  color: var(--gray-700);\n}\n\n.password-hint {\n  font-size: var(--font-size-xs);\n  color: var(--gray-500);\n  margin-top: var(--space-xs);\n  font-style: italic;\n}\n\n.form-actions {\n  display: flex;\n  gap: var(--space-md);\n  justify-content: flex-end;\n  padding-top: var(--space-lg);\n  border-top: 1px solid var(--gray-200);\n}\n\n.cancel-btn {\n  background: var(--gray-100);\n  color: var(--gray-700);\n  border: 1px solid var(--gray-300);\n  padding: var(--space-md) var(--space-xl);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-medium);\n  transition: all var(--transition-fast);\n}\n\n.cancel-btn:hover {\n  background: var(--gray-200);\n  border-color: var(--gray-400);\n}\n\n.create-btn,\n.save-btn {\n  background: linear-gradient(135deg, var(--primary-color) 0%, var(--primary-light) 100%);\n  color: var(--white);\n  border: none;\n  padding: var(--space-md) var(--space-xl);\n  border-radius: var(--radius-lg);\n  cursor: pointer;\n  font-size: var(--font-size-sm);\n  font-weight: var(--font-weight-semibold);\n  transition: all var(--transition-base);\n  box-shadow: var(--shadow-md);\n}\n\n.create-btn:hover,\n.save-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-lg);\n/* Access Management Styles */\n.access-list {\n  padding: var(--space-xl);\n}\n\n.access-header h4 {\n  margin: 0 0 var(--space-sm) 0;\n  color: var(--primary-color);\n  font-size: var(--font-size-lg);\n  font-weight: var(--font-weight-bold);\n}\n\n.access-header p {\n  margin: 0 0 var(--space-xl) 0;\n  color: var(--gray-600);\n  font-size: var(--font-size-sm);\n  line-height: var(--line-height-relaxed);\n}\n\n.instances-grid {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-md);\n  max-height: 400px;\n  overflow-y: auto;\n}\n\n.access-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: var(--space-lg);\n  background: var(--gray-50);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--gray-200);\n  transition: all var(--transition-base);\n}\n\n.access-item:hover {\n  background: var(--gray-100);\n  border-color: var(--primary-color);\n}\n\n.instance-info {\n  flex: 1;\n}\n\n.instance-name {\n  font-weight: var(--font-weight-semibold);\n  color: var(--gray-700);\n  font-size: var(--font-size-base);\n  margin-bottom: var(--space-xs);\n}\n\n.instance-details {\n  font-size: var(--font-size-sm);\n  color: var(--gray-500);\n}\n\n.instance-details .status {\n  font-weight: var(--font-weight-semibold);\n  text-transform: uppercase;\n}\n\n.instance-details .status.connected {\n  color: var(--success-color);\n}\n\n.instance-details .status.connecting {\n  color: var(--warning-color);\n}\n\n.instance-details .status.disconnected {\n  color: var(--error-color);\n}\n\n.access-control {\n  margin-left: var(--space-lg);\n}\n\n/* Toggle Switch */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--gray-300);\n  transition: all var(--transition-base);\n  border-radius: 34px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: var(--white);\n  transition: all var(--transition-base);\n  border-radius: 50%;\n  box-shadow: var(--shadow-sm);\n}\n\ninput:checked + .toggle-slider {\n  background-color: var(--primary-color);\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(26px);\n}\n\n.modal-footer {\n  padding: var(--space-xl);\n  background: var(--gray-50);\n  border-top: 1px solid var(--gray-200);\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--space-md);\n}\n\n/* Loading State */\n.loading {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  background: var(--white);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .table-header,\n  .table-row {\n    grid-template-columns: 2fr 1fr 1fr 1.5fr;\n  }\n  \n  .header-cell:last-child,\n  .table-cell:last-child {\n    grid-column: 1 / -1;\n    margin-top: var(--space-sm);\n  }\n}\n\n@media (max-width: 768px) {\n  .user-manager {\n    padding: 0;\n  }\n  \n  .user-header {\n    flex-direction: column;\n    gap: var(--space-lg);\n    align-items: stretch;\n    text-align: center;\n  }\n  \n  .users-table {\n    overflow-x: auto;\n  }\n  \n  .table-header,\n  .table-row {\n    grid-template-columns: 1fr;\n    gap: var(--space-sm);\n    text-align: center;\n  }\n  \n  .table-header {\n    display: none;\n  }\n  \n  .table-row {\n    display: flex;\n    flex-direction: column;\n    padding: var(--space-lg);\n    border: 1px solid var(--gray-200);\n    border-radius: var(--radius-lg);\n    margin-bottom: var(--space-md);\n    background: var(--white);\n  }\n  \n  .table-cell {\n    justify-content: center;\n    border-bottom: 1px solid var(--gray-100);\n    padding-bottom: var(--space-sm);\n    margin-bottom: var(--space-sm);\n  }\n  \n  .table-cell:last-child {\n    border-bottom: none;\n    margin-bottom: 0;\n    padding-bottom: 0;\n  }\n  \n  .action-buttons {\n    flex-direction: column;\n    width: 100%;\n  }\n  \n  .edit-btn,\n  .manage-access-btn {\n    width: 100%;\n    justify-content: center;\n  }\n  \n  .modal-content {\n    margin: var(--space-md);\n    max-width: calc(100vw - 2rem);\n  }\n  \n  .access-modal-content {\n    max-width: calc(100vw - 2rem);\n  }\n  \n  .instances-grid {\n    max-height: 300px;\n  }\n  \n  .access-item {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: var(--space-md);\n  }\n  \n  .access-control {\n    margin-left: 0;\n    align-self: flex-end;\n  }\n}\n\n@media (max-width: 480px) {\n  .user-header,\n  .user-form,\n  .access-list,\n  .modal-footer {\n    padding: var(--space-md);\n  }\n  \n  .form-actions,\n  .modal-footer {\n    flex-direction: column;\n  }\n  \n  .cancel-btn,\n  .create-btn,\n  .save-btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n  border-radius: 8px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n  box-sizing: border-box;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #25D366;\n}\n\n.form-actions {\n  display: flex;\n  gap: 12px;\n  padding-top: 16px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.cancel-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  flex: 1;\n  transition: background-color 0.3s ease;\n}\n\n.cancel-btn:hover {\n  background: #545b62;\n}\n\n.create-btn {\n  background: #25D366;\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 14px;\n  flex: 1;\n  transition: background-color 0.3s ease;\n}\n\n.create-btn:hover {\n  background: #1da851;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 200px;\n  font-size: 16px;\n  color: #666;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .table-header,\n  .table-row {\n    grid-template-columns: 1fr;\n    gap: 8px;\n  }\n  \n  .table-cell {\n    justify-content: space-between;\n    padding: 4px 0;\n  }\n  \n  .table-cell::before {\n    content: attr(data-label);\n    font-weight: 600;\n    color: #075E54;\n    font-size: 12px;\n    text-transform: uppercase;\n  }\n  \n  .header-cell {\n    display: none;\n  }\n  \n  .user-header {\n    flex-direction: column;\n    gap: 16px;\n    align-items: stretch;\n  }\n  \n  .user-header h2 {\n    text-align: center;\n  }\n}\n\n/* Action Buttons Styling */\n.action-buttons {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n}\n\n.edit-btn {\n  background: #ffc107;\n  color: #000;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.edit-btn:hover {\n  background: #e0a800;\n  transform: translateY(-1px);\n}\n\n.manage-access-btn {\n  background: #007bff;\n  color: white;\n  border: none;\n  padding: 8px 12px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 12px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.manage-access-btn:hover {\n  background: #0056b3;\n  transform: translateY(-1px);\n}\n\n/* Edit User Modal */\n.edit-user-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n/* Access Modal Enhanced Styling */\n.assign-access-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 20px;\n}\n\n.access-modal-content {\n  max-width: 600px !important;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.access-header {\n  margin-bottom: 20px;\n}\n\n.access-header h4 {\n  margin: 0 0 8px 0;\n  color: #075E54;\n  font-size: 18px;\n}\n\n.access-header p {\n  margin: 0;\n  color: #666;\n  font-size: 14px;\n}\n\n.instances-grid {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.access-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: #f8f9fa;\n  transition: all 0.3s ease;\n}\n\n.access-item:hover {\n  background: #e9ecef;\n  border-color: #007bff;\n}\n\n.instance-info {\n  flex: 1;\n}\n\n.instance-name {\n  font-weight: 600;\n  color: #333;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.instance-details {\n  font-size: 12px;\n  color: #666;\n}\n\n.instance-details .status {\n  font-weight: 500;\n  text-transform: capitalize;\n}\n\n.instance-details .status.connected {\n  color: #28a745;\n}\n\n.instance-details .status.disconnected {\n  color: #dc3545;\n}\n\n.access-control {\n  margin-left: 16px;\n}\n\n/* Toggle Switch Styling */\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 24px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: 0.4s;\n  border-radius: 24px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 18px;\n  width: 18px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background-color: #25D366;\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(26px);\n}\n\n/* Modal Footer */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n  margin-top: 24px;\n  padding-top: 20px;\n  border-top: 1px solid #e0e0e0;\n}\n\n.save-btn {\n  background: #25D366;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.save-btn:hover {\n  background: #1da851;\n  transform: translateY(-1px);\n}\n\n/* Responsive for mobile */\n@media (max-width: 768px) {\n  .action-buttons {\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .edit-btn, .manage-access-btn {\n    width: 100%;\n    text-align: center;\n  }\n  \n  .access-modal-content {\n    margin: 10px;\n    max-height: 90vh;\n  }\n  \n  .access-item {\n    flex-direction: column;\n    gap: 12px;\n    text-align: center;\n  }\n  \n  .access-control {\n    margin-left: 0;\n  }\n}\n\n/* Password Section Styling */\n.password-section {\n  border-top: 1px solid #e0e0e0;\n  margin-top: 16px;\n  padding-top: 16px;\n}\n\n.checkbox-label {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  margin: 0;\n}\n\n.checkbox-label input[type=\"checkbox\"] {\n  margin: 0;\n  transform: scale(1.1);\n}\n\n.checkbox-text {\n  font-weight: 500;\n  color: #333;\n}\n\n.password-hint {\n  display: block;\n  margin-top: 4px;\n  color: #666;\n  font-size: 12px;\n  font-style: italic;\n}\n\n/* Enhanced Form Groups */\n.form-group label {\n  display: block;\n  margin-bottom: 6px;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-group input[type=\"text\"],\n.form-group input[type=\"password\"],\n.form-group select {\n  width: 100%;\n  padding: 10px 12px;\n  border: 1px solid #ddd;\n  border-radius: 6px;\n  font-size: 14px;\n  transition: border-color 0.3s ease;\n}\n\n.form-group input[type=\"text\"]:focus,\n.form-group input[type=\"password\"]:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* Validation States */\n.form-group input:invalid {\n  border-color: #dc3545;\n}\n\n.form-group input:valid {\n  border-color: #28a745;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
